<template lang="pug">
#page_topic.page
	Banner(v-bind:item='list_banner_full', classes='list_video')
	#page_content.page
		.container.article
			img.banner(src='~@/assets/images/topic_top.png')
			template(v-if='$i18n.locale === "tw"')
				.row.justify-content-center: .col-sm-10
					p.content 邁入第十屆！自2004年起走過18個年頭，年年風雨無阻、次次更加精彩，今年台灣國際兒童影展迎來成年禮，推出40多部好片，讓全台各地的小朋友都能一同欣賞。
					h2 3/14~4/18 線上影音平台「公視+」免費收看
					p.content 記得先註冊「公視+」會員哦！多數影片限時五周免費觀賞，敬請把握！
					p
						| ★ 前往「公視+」兒童影展專區｜
						a(href='https://www.ptsplus.tv/channel/15', target='_blank') 請點此
						br
						| ★ 收看映前導讀、映後座談｜
						a(href='https://www.facebook.com/TICFF.tw/videos', target='_blank') 請點此
						br
						| ★ 參與周邊活動、線上直播｜
						a(href='https://www.facebook.com/TICFF.tw/events/', target='_blank') 請點此
					ol
						li 影展年度主題：未來旋轉門（3部）
						li 觀摩單元：勇氣加值中（7部）
						li 觀摩單元：奇幻心歷險 （7部）
						li 觀摩單元：親情三溫暖 （6部）
						li 觀摩單元：陪著你長大（5部）
						li 觀摩單元：翻轉腦細胞 （6部）
						li 觀摩單元：小寶貝也看得懂（8部）
					p
						| 註1: 請記得要先註冊公視+會員，即可免費遍覽所有影展影片｜
						router-link(to='/ott') 註冊教學
						br
						| 註2: 因版權因素，本次線上影片只限台灣觀賞，造成不便敬請見諒。
						br
						| 註3: 非英語發音影片均有雙語字幕，歡迎台灣的外國觀眾收看。
					p ★★ 觀摩片單一覽表：
					.d-flex.justify-content-center
						img.list(src='~@/assets/images/topic_list.png')

			template(v-else)
				.row.justify-content-center: .col-sm-10
					p.content Entering its 10th edition this year, Taiwan International Children’s Film Festival (TICFF) has come a long way since its humble beginnings in 2004. Spanning 18 years, TICFF has never failed to deliver, consistently showcasing high quality films and programs for children. This year, TICFF is celebrating its coming of age with more than 40 films for children all over Taiwan to enjoy!
					h2 From 3/14~4/18 catch the 10th TICFF on PTS+, free to view!
					p.content Make sure to sign up for PTS+ to watch all our content for free, available for 5 weeks!
					p
						| ★ PTS+ TICFF Channel｜
						a(href='https://www.ptsplus.tv/channel/15', target='_blank') Click Here
						br
						| ★ Film Introduction & Discussion｜
						a(href='https://www.facebook.com/TICFF.tw/videos', target='_blank') Click Here
						br
						| ★ Festival Events & Livestreams｜
						a(href='https://www.facebook.com/TICFF.tw/events/', target='_blank') Click Here
					ol
						li Annual Theme: Future-go-round (3 total)
						li Official Selection: Courageous Me（7 total）
						li Official Selection: Journeys of Fantasy (7 total)
						li Official Selection: Our Family Medley (6 total)
						li Official Selection: Growing Together (5 total)
						li Official Selection: Brain Blast(6 total)
						li Official Selection: Tiny Tales for Tiny Tots (8 total)
					p
						| * Remember to sign up for PTS+ to enjoy all our content for free｜
						router-link(to='/ott') How to sign up
						br
						| * Due to copyright restrictions, all videos on PTS+ are only available for viewing in Taiwan, we apologize for the inconvenience.
						br
						| * All non-English films will have dual subtitles (ENG/CH). Foreigner friends in Taiwan are welcome to watch along!
					p ★★ Official Selection Watch List
					.d-flex.justify-content-center
						img.list(src='~@/assets/images/topic_list_en.png')
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			list_banner_full: {
				media: 'assets/images/topic_banner.png',
				title: this.$t('video_topic_banner_title'),
				category: this.$t('video_topic_banner_category'),
				desc: this.$t('video_topic_banner_desc'),
				link_yt: 'https://www.youtube.com/embed/gKo3Lyxet6M',
			},
		};
	},
	watch: {
		'$i18n.locale'() {
			this.list_banner_full.title = this.$t('video_topic_banner_title');
			// prettier-ignore
			this.list_banner_full.category = this.$t('video_topic_banner_category');

			this.list_banner_full.desc = this.$t('video_topic_banner_desc');
		},
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_topic.page
	#page_content
		.article
			background-color: rgba(11, 46, 91, 0)
			padding: 0 0 6rem 0
			img
				margin-bottom: 6rem
				&.list
					width: 60%
					margin-bottom: 0
					border-radius: 1.5rem
			img.banner
				display: flex
				width: auto
				height: 500px
				margin: 3rem auto 3rem
			a
				color: $color_yellow
	@media screen and (max-width: $screen-sm-max)
		#page_content
			.article
				padding: 2rem 20px
				img.banner, img.list
					width: 100%
					height: auto
</style>
